import { useState, useContext, useEffect } from "react";
import { BarbershopContext } from "../../providers/useProvider";
import useLogin from "../../hooks/useLogin";
import { Link } from "react-router-dom";

import "./login.css";
const Login = () => {
  const { handleLogin, loading, error } = useLogin();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  useEffect(() => {});
  const config = useContext(BarbershopContext);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await handleLogin(formData);
  };
  if (!config.config?.brandName) {
    return <p>Loading...</p>;
  } else {
    return (
      <div
        className="d-flex justify-content-center h-100
"
      >
        <div className="d-flex align-items-center">
          <div className="login-card row g-0 shadow-lg">
            <div className="row g-0">
              <div className="col-12 col-md-6 image-side">
                <div>
                  <h2>Find your sweet home</h2>
                  <p>
                    Schedule visits in just a few clicks.
                    <br />
                    Your dream property awaits.
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-12 d-flex align-items-center justify-content-center form-side">
                <div className="w-100">
                  <h4 className="login-title mb-2 text-color">
                    Welcome back to {config.config.brandName}!
                  </h4>
                  <p className="login-subtitle mb-4">Sign in to your account</p>
                  {error && (
                    <div className="alert alert-danger py-2">{error}</div>
                  )}
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label
                        for="email"
                        className="form-label small text-muted"
                      >
                        Your Email
                      </label>
                      <input
                        id="email"
                        name="email"
                        type="email"
                        className="form-control login-input "
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <div className="d-flex justify-content-between">
                        <label
                          for="password"
                          className="form-label small text-muted mb-0"
                        >
                          Password
                        </label>
                        <Link
                          to="/forget-password"
                          className="text-decoration-none pr-2 login-link"
                          role="button"
                        >
                          Forgot Password?
                        </Link>
                      </div>
                      <input
                        id="password"
                        name="password"
                        type="password"
                        className="form-control login-input "
                        value={formData.password}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-check mb-3 remember-input">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="remember"
                      />
                      <label
                        className="form-check-label  remember-label  small"
                        for="remember"
                      >
                        Remember Me
                      </label>
                    </div>
                    <button type="submit" className="btn login-btn  mb-3">
                      Login
                    </button>
                    {/* <div className="text-center text-muted small mb-2">
                      Instant Login
                    </div> */}
                    {/* <div className="d-flex gap-2 mb-3">
                      <button
                        type="button"
                        className="btn btn-outline-secondary w-50"
                      >
                        <img
                          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/google/google-original.svg"
                          alt="Google"
                          width="18"
                          className="me-2"
                        />
                        Continue with Google
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-secondary w-50"
                      >
                        <img
                          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/facebook/facebook-original.svg"
                          alt="Facebook"
                          width="18"
                          className="me-2"
                        />
                        Continue with Facebook
                      </button>
                    </div> */}
                    <p className="text-center small text-muted mb-0">
                      Don’t have an account?
                      <Link
                        to="/register"
                        className="text-decoration-none login-link pr-2"
                        role="button"
                      >
                        Register
                      </Link>
                    </p>
                    <div className="d-flex justify-content-end">
                      <Link
                        to="/"
                        className="text-decoration-none login-link pr-2"
                        role="button"
                      >
                        Back
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default Login;
